import reviewService from '@/_service/review.service';
import { Box, Button, Stack, Text } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { IBranch } from '@/_types';
import ReviewCard from '../components/review-card'
import { useState, useMemo } from 'react'
import ReviewForm from '../components/review-form'

export default function Reviews({ data }: { data: IBranch }) {
  const t = useTranslations();

  const { data: reviews, refetch } = useQuery({
    queryKey: ['reviews-branch', data?.id],
    queryFn: () =>
      reviewService
        .getByBranch(data?.id, { page: 1, limit: 10 })
        .then((res) => res?.data),
  });

  const filteredReviews = useMemo(() => {
    return reviews?.reviews?.filter(el => el.rating >= 4) || [];
  }, [reviews?.reviews]);

  return (
    <Stack pb={100}>
      {filteredReviews.length > 0 ? (
        filteredReviews.map((el) => <ReviewCard key={el.id} data={el} />)
      ) : (
        <Text textAlign={'center'} my={4} fontSize={'lg'} fontWeight={600}>
          {t('no_reviews')}
        </Text>
      )}
      <Box position="fixed" zIndex={40} bottom={0} left={0} right={0} p={4} bg="white" borderTop="1px solid #E0E0E0">
        <LeaveFeedbackButton data={data} refetch={refetch} />
      </Box>
    </Stack>

  );
}

function LeaveFeedbackButton({ data, refetch }: { data: IBranch, refetch: () => void }) {
  const [isOpen, setIsOpen] = useState(false)
  const t = useTranslations()
  return (
    <>
      <Button w="full" h={'56px'} variant='solid' bg={'primary'} rounded={16} mb={2} onClick={() => setIsOpen(true)}>
        {t('leave_feedback')}
      </Button>
      <ReviewForm isOpen={isOpen} onClose={() => setIsOpen(false)} branch={data} refetch={refetch} />
    </>
  )
}
